import clsx from 'clsx';
import { Base } from '../Base';
import Placeholder from './Placeholder';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "root": "FqdnPlaceholder-root_25oQQ",
  "domain": "FqdnPlaceholder-domain_14Ear",
  "dot": "FqdnPlaceholder-dot_DBHSe",
  "tld": "FqdnPlaceholder-tld_1E95P"
};
function FqdnPlaceholder({
  className,
  ...extraProps
}) {
  return /*#__PURE__*/_jsxs(Base, {
    tagName: "span",
    flex: true,
    flexAlignItemsCenter: true,
    className: clsx(styles.root, className),
    ...extraProps,
    children: [/*#__PURE__*/_jsx(Placeholder, {
      chars: 15,
      className: styles.domain
    }), /*#__PURE__*/_jsx(Placeholder, {
      chars: 1,
      className: styles.dot
    }), /*#__PURE__*/_jsx(Placeholder, {
      chars: 3,
      className: styles.tld
    })]
  });
}
export default FqdnPlaceholder;